import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import { BlogSubscription } from "./Components/BlogSubscription.jsx";

export function RenderBlogSubcriptions(configuration){
  const container = document.getElementById(configuration.container);
  const root = createRoot(container);

  root.render(
    (
        <BlogSubscription configuration={configuration} />
    ),
  );
}


document.addEventListener("DOMContentLoaded", function() {
  const widget_configs = document.querySelectorAll(".blog-subscription-widget-config");

  for (let config of widget_configs) {
    RenderBlogSubcriptions(JSON.parse(config.innerText));
  }
});
